import React, { useState, useEffect } from "react";
import axios from "axios";
import { Container, Card, Row, Col, Button, Form } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import { BASE_URL } from "../../../constants";
import "../../../CommonCSS/SocietyCSS.css";
import EditCashBankModal from './EditCashBankModal';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CashBankMaster = () => {
  const [formData, setFormData] = useState({
    cb_code: "",
    cb_type: "",
    cb_title: "",
    grp_cd: "",
    sub_grp_cd: "",
    acct_status: "",
    bank_name: "",
    bank_acc_no: "",
    bank_branch: "",
    ifsc: "",
    addr1: "",
    addr2: "",
    phone_no: "",
    email_id: "",
    cont_person: "",
    cont_person_no: "",
  });

  const [isEditable, setIsEditable] = useState(false);
  const [groupList, setGroupList] = useState([]);
  const [subGroupList, setSubGroupList] = useState([]);

  const [isLocked, setIsLocked] = useState(false);
  const [showsearchModal, setShowSearchModal] = useState(false);
  //const [isEditMode, setIsEditMode] = useState(false);

  // Fetch Groups from API
  useEffect(() => {
    const fetchGroups = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/api/ddl_fin_group`);
        setGroupList(res.data || []);
      } catch (error) {
        console.error("Error fetching groups:", error);
      }
    };
    fetchGroups();
  }, []);

  // Fetch Sub-Groups when Group changes
  useEffect(() => {
    if (!formData.grp_cd) return;
    const fetchSubGroups = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/api/ddl_fin_sub_group`, {params: {p_GroupCd: formData.grp_cd }} );
        setSubGroupList(res.data || []);
      } catch (error) {
        console.error("Error fetching subgroups:", error);
      }
    };
    fetchSubGroups();
  }, [formData.grp_cd]);

  const handleNew = () => {
    setIsEditable(true);
    setFormData((prev) => ({ ...prev, 'acct_status': 'A' }));
  }


  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle Save
  const handleSave = async () => {

    if (!formData.cb_type || formData.cb_type === '' ) {
      toast.error('Please select Account Type.');
      return;
    }

    if (!formData.cb_title || formData.cb_title === '' ) {
      toast.error('Please enter Cash/Bank Title.');
      return;
    }

    if (!formData.acct_status || formData.acct_status === '' ) {
      toast.error('Please select Status.');
      return;
    }

    if (!formData.grp_cd || formData.grp_cd === '' ) {
      toast.error('Please select Group');
      return;
    }

    if (formData.cb_type === 'CURR' || formData.cb_type === 'SAVE') {
      if (!formData.bank_name || formData.bank_name === '') {
        toast.error('Please enter Bank Name.');
        return;
      }
    }

    const confirmSave = window.confirm("Sure you want to save the record?");
    if (!confirmSave) return;

    const cashbankData = {
      cbData: formData,
    };

    try {
      const res = await axios.post(`${BASE_URL}/api/save_cashbank_master`, cashbankData);
      if (res.data.message === "1") {
        toast.success("Cash/Bank Master saved successfully!");
        reset_page();
      }
    } catch (error) {
      toast.error("Error saving Finance Cash/Bank Master data!");
      console.error(error);
    }
  };

  const reset_page = () => {
    setFormData({
      cb_code: "",
      cb_type: "",
      cb_title: "",
      grp_cd: "",
      sub_grp_cd: "",
      acct_status: "",
      bank_name: "",
      bank_acc_no: "",
      bank_branch: "",
      ifsc: "",
      addr1: "",
      addr2: "",
      phone_no: "",
      email_id: "",
      cont_person: "",
      cont_person_no: "",
    });
    setIsEditable(false);
    setIsLocked(false);
  }

  // Handle Clear
  const handleClear = () => {
    const confirmSave = window.confirm("Sure you want to clear the page?");
    if (!confirmSave) return;

    reset_page();
  };


    /// for Edit
  const handleCashBankRowSelect = async (selRow) => {

    setShowSearchModal(false);
    formData.cb_code = selRow.cb_code;

    const response = await axios.get(`${BASE_URL}/api/get_cashbank_ByIds`, {params: { p_CB_Code: selRow.cb_code}});

    setFormData({
      cb_code: response.data[0].cb_code,
      cb_type: response.data[0].cb_type,
      cb_title: response.data[0].cb_title,
      grp_cd: response.data[0].grp_cd,
      sub_grp_cd: response.data[0].sub_grp_cd,
      acct_status: response.data[0].acct_status,
      bank_name: response.data[0].bank_name,
      bank_acc_no: response.data[0].bank_acc_no,
      bank_branch: response.data[0].bank_branch,
      ifsc: response.data[0].ifsc,
      addr1: response.data[0].addr1,
      addr2: response.data[0].addr2,
      phone_no: response.data[0].phone_no,
      email_id: response.data[0].email_id,
      cont_person: response.data[0].cont_person,
      cont_person_no: response.data[0].cont_person_no,
    });

    //setSlots(response.data);

    setIsEditable(true);
    setIsLocked(true);
    //setIsEditMode(true);

  };

  return (
    <Container fluid className="p-3">
      <Card className="p-4 shadow-sm">
        {/* <h4 className="text-center mb-4">Finance Cash / Bank Master</h4> */}

        {/* --- Basic Details --- */}
        <Row className="mb-3">
          {/* <Col md={4}>
            <Form.Label>CB Code:</Form.Label>
            <Form.Control type="text" name="cb_code" value={formData.cb_code} disabled placeholder="Auto-generated" />
          </Col> */}

          <Col md={3}>
            <Form.Label>Account Type:</Form.Label>
            <Form.Select name="cb_type" value={formData.cb_type} onChange={handleChange} disabled={!isEditable || isLocked}>
              <option value="">-- Select Type --</option>
              <option value="CASH">CASH A/C</option>
              <option value="CURR">CURRENT A/C</option>
              <option value="SAVE">SAVING A/C</option>
            </Form.Select>
          </Col>

          <Col md={6}>
            <Form.Label>Cash/Bank Title:</Form.Label>
            <Form.Control type="text" name="cb_title" value={formData.cb_title.toLocaleUpperCase()}
              onChange={handleChange} disabled={!isEditable}
            />
          </Col>

          <Col md={3}>
            <Form.Label>Account Status:</Form.Label>
            <Form.Select name="acct_status" value={formData.acct_status} onChange={handleChange} disabled={!isEditable}>
              <option value="">-- Select Status --</option>
              <option value="A">ACTIVE</option>
              <option value="C">CLOSED</option>
            </Form.Select>
          </Col>

        </Row>

        {/* --- Group Details --- */}
        <Row className="mb-3">
          <Col md={3}>
            <Form.Label>Group:</Form.Label>
            <Form.Select name="grp_cd" value={formData.grp_cd} onChange={handleChange} disabled={!isEditable}>
              <option value="">-- Select Group --</option>
              {groupList.map((grp) => (
                <option key={grp.grp_cd} value={grp.grp_cd}>
                  {grp.grp_desc}
                </option>
              ))}
            </Form.Select>
          </Col>

          <Col md={3}>
            <Form.Label>Sub Group:</Form.Label>
            <Form.Select name="sub_grp_cd" value={formData.sub_grp_cd} onChange={handleChange} disabled={!isEditable}>
              <option value="">-- Select Sub Group --</option>
              {subGroupList.map((sub) => (
                <option key={sub.sub_grp_cd} value={sub.sub_grp_cd}>
                  {sub.sub_grp_desc}
                </option>
              ))}
            </Form.Select>
          </Col>
        {/* --- Dates --- */}
          {/* <Col md={3}>
            <Form.Label>Account Start Date:</Form.Label>
            <Form.Control
              type="date"
              name="acct_start_date"
              value={formData.acct_start_date}
              onChange={handleChange}
              disabled={!isEditable}
            />
          </Col>
          <Col md={3}>
            <Form.Label>Account End Date:</Form.Label>
            <Form.Control
              type="date"
              name="acct_end_date"
              value={formData.acct_end_date}
              onChange={handleChange}
              disabled={!isEditable}
            />
          </Col> */}

        </Row>

        {/* <Row className="mb-3">
        </Row> */}

        {/* --- Bank Details: Only visible if CURR or SAVE --- */}
        {(formData.cb_type === "CURR" || formData.cb_type === "SAVE") && (
          <>
            <hr />
            <h5 className="mb-3 text-center text-primary">Bank Details</h5>

            <Row className="mb-3">
              <Col md={3}>
                <Form.Label>Bank Name:</Form.Label>
                <Form.Control
                  type="text"
                  name="bank_name"
                  value={formData.bank_name.toLocaleUpperCase()}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </Col>
              <Col md={3}>
                <Form.Label>Bank Account No:</Form.Label>
                <Form.Control
                  type="text"
                  name="bank_acc_no"
                  value={formData.bank_acc_no}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </Col>

              <Col md={3}>
                <Form.Label>Branch:</Form.Label>
                <Form.Control
                  type="text"
                  name="bank_branch"
                  value={formData.bank_branch.toLocaleUpperCase()}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </Col>
              <Col md={3}>
                <Form.Label>IFSC:</Form.Label>
                <Form.Control
                  type="text"
                  name="ifsc"
                  value={formData.ifsc}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </Col>

            </Row>

            <Row className="mb-3">
              <Col md={3}>
                <Form.Label>Address Line 1:</Form.Label>
                <Form.Control
                  type="text"
                  name="addr1"
                  value={formData.addr1}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </Col>
              <Col md={3}>
                <Form.Label>Address Line 2:</Form.Label>
                <Form.Control
                  type="text"
                  name="addr2"
                  value={formData.addr2}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </Col>

              <Col md={3}>
                <Form.Label>Phone No:</Form.Label>
                <Form.Control
                  type="text"
                  name="phone_no"
                  value={formData.phone_no}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </Col>
              <Col md={3}>
                <Form.Label>eMail ID:</Form.Label>
                <Form.Control
                  type="email"
                  name="email_id"
                  value={formData.email_id}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </Col>

            </Row>

            <Row className="mb-3">
              <Col md={3}>
                <Form.Label>Contact Person:</Form.Label>
                <Form.Control
                  type="text"
                  name="cont_person"
                  value={formData.cont_person.toLocaleUpperCase()}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </Col>
              <Col md={3}>
                <Form.Label>Contact Person Phone:</Form.Label>
                <Form.Control
                  type="text"
                  name="cont_person_no"
                  value={formData.cont_person_no}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </Col>

            </Row>
          </>
        )}

        {/* --- Action Buttons --- */}
        <Row className="mt-1 justify-content-end">
          <Col md="auto">
            <Button variant="primary" className="me-2" style={{width: "100px"}} onClick={handleNew} disabled={isEditable}>New </Button>
            <Button variant="secondary" className="me-2" style={{width: "100px"}} onClick={handleClear} disabled={!isEditable}>Clear</Button>
            <Button variant="warning" className="me-2" style={{width: "100px"}} onClick={() => setShowSearchModal(true)} disabled={isEditable}>Edit</Button>
            {showsearchModal && (
            <EditCashBankModal
              show={showsearchModal}
              handleClose={() => setShowSearchModal(false)}
              onRowSelect={handleCashBankRowSelect}
              // handleSave={handleSave}
            />
            )}
            <Button variant="success" style={{width: "100px"}} onClick={handleSave} disabled={!isEditable}>Save</Button>
          </Col>
        </Row>
      </Card>
    </Container>
  );
};

export default CashBankMaster;
